import React, { Component, PropTypes } from 'react'

import { getProperty, filterObject, weightUnitOptions } from '../utils'
import { Loading } from '../misc'
import {
    Boolean,
    Label,
    Select,
    TextInput,
} from '../ui'

export default class Steadicam extends Component {
    static propTypes = {
        crewType: PropTypes.string.isRequired,
        crew_uuid: PropTypes.string.isRequired,
        data: PropTypes.object.isRequired,
        gear: PropTypes.object.isRequired,
        gearActions: PropTypes.object.isRequired,
        updateValue: PropTypes.func.isRequired,
    }

    _updateValueAndSendPatchRequest = (data) => {
        this.props.updateValue(data)
        this._sendPatchRequest(data)
    }

    _sendPatchRequest = (data = this.props.data) => {
        const newData = filterObject(
            data,
            [
                'steadicam_make',
                'steadicam_model',
                'steadicam_wireless_focus',
                'steadicam_wireless_video',
                'steadicam_max_camera_weight',
                'steadicam_max_camera_weight_unit',
                'steadicam_additional_kit_items',
                'steadicam_has_camera',
            ],
        )

        this.props.gearActions.patchGear(newData, this.props.crew_uuid, this.props.crewType)
    }

    render() {
        if (! this.props.data) {
            return <Loading />
        }

        const errors = this.props.gear.errors

        return (
            <div className="content__inner">
                <div className="box">
                    <div className="box__header">
                        <div className="box__title">
                            Steadicam Kit
                        </div>
                    </div>
                    <div className="box__content box__content--padded">
                        <Label>Steadicam rig:</Label>
                        <TextInput
                            error={ errors.steadicam_make }
                            handleBlur={ this._sendPatchRequest }
                            name="steadicam_make"
                            placeholder="Enter make"
                            updateValue={ this.props.updateValue }
                            value={ getProperty(this.props.data, 'steadicam_make') }
                        />
                        <TextInput
                            error={ errors.steadicam_model }
                            handleBlur={ this._sendPatchRequest }
                            name="steadicam_model"
                            placeholder="Enter model"
                            updateValue={ this.props.updateValue }
                            value={ getProperty(this.props.data, 'steadicam_model') }
                        />

                        <div className="grid grid--break-mobile">
                            <div className="grid__span-6">
                                <Boolean
                                    error={ errors.steadicam_wireless_focus }
                                    label="Wireless focus:"
                                    name="steadicam_wireless_focus"
                                    updateValue={ this._updateValueAndSendPatchRequest }
                                    value={ getProperty(this.props.data, 'steadicam_wireless_focus') }
                                />
                            </div>
                            <div className="grid__span-6">
                                <Boolean
                                    error={ errors.steadicam_wireless_video }
                                    label="Wireless video:"
                                    name="steadicam_wireless_video"
                                    updateValue={ this._updateValueAndSendPatchRequest }
                                    value={ getProperty(this.props.data, 'steadicam_wireless_video') }
                                />
                            </div>
                        </div>

                        <div className="grid grid--break-mobile">
                            <div className="grid__span-3">
                                <Label inline>Max camera weight:</Label>
                            </div>
                            <div className="grid__span-3">
                                <TextInput
                                    error={ errors.steadicam_max_camera_weight }
                                    handleBlur={ this._sendPatchRequest }
                                    name="steadicam_max_camera_weight"
                                    type="number"
                                    updateValue={ this.props.updateValue }
                                    value={ getProperty(this.props.data, 'steadicam_max_camera_weight') }
                                />
                            </div>
                            <div className="grid__span-2">
                                <Select
                                    error={ errors.steadicam_max_camera_weight_unit }
                                    name="steadicam_max_camera_weight_unit"
                                    options={ weightUnitOptions() }
                                    updateValue={ this._updateValueAndSendPatchRequest }
                                    value={ getProperty(this.props.data, 'steadicam_max_camera_weight_unit') }
                                />
                            </div>
                        </div>

                        <Label>Additional kit items:</Label>
                        <TextInput
                            error={ errors.steadicam_additional_kit_items }
                            handleBlur={ this._sendPatchRequest }
                            name="steadicam_additional_kit_items"
                            rows="5"
                            type="textarea"
                            updateValue={ this.props.updateValue }
                            value={ getProperty(this.props.data, 'steadicam_additional_kit_items') }
                        />

                        <Boolean
                            error={ errors.steadicam_has_camera }
                            label="Do you own a camera package?"
                            name="steadicam_has_camera"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'steadicam_has_camera') }
                        />
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/gear/steadicam.js